import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import Linkify from "~/components/Linkify";
export const EditableMultilineTextTriggerButton = /*#__PURE__*/ memo((param)=>{
    let { placeholder, className, style, value, ...restProps } = param;
    return /*#__PURE__*/ _jsx(Button, {
        className: tailwindMerge("whitespace-pre-wrap px-2 py-1 text-left text-12 font-normal", !!value ? "text-grey-11" : "text-grey-7", className),
        appearance: "ghost",
        color: "grey",
        style: {
            wordBreak: "break-word",
            ...style
        },
        ...restProps,
        children: /*#__PURE__*/ _jsx("div", {
            className: "size-full overflow-hidden text-left",
            children: value ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Linkify, {
                        children: value
                    }),
                    value.includes("\n") && /*#__PURE__*/ _jsx(_Fragment, {
                        children: "\xa0"
                    })
                ]
            }) : placeholder
        })
    });
});
EditableMultilineTextTriggerButton.displayName = "EditableMultilineTextTriggerButtonProps";
